module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Myths&Monsters.f911f12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Myths&Monsters.jpg
// module id = 3HMy
// module chunks = 0